import type { AnchorHTMLAttributes } from "react";
import { isSafeExternalUrl } from "../../lib/url";

interface SafeLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string | null | undefined;
}

/**
 * Renders an external link ONLY for http(s) URLs. An unsafe scheme
 * (javascript:, data:, etc.) or a malformed value renders as plain text
 * instead of a clickable element — Step 12's explicit requirement.
 */
export function SafeLink({ href, children, className = "", ...rest }: SafeLinkProps) {
  if (!isSafeExternalUrl(href)) {
    return <span className={className}>{children}</span>;
  }

  return (
    <a href={href as string} target="_blank" rel="noopener noreferrer" className={className} {...rest}>
      {children}
    </a>
  );
}
